import LoadingSpinner from '@elements/loadingSpinner/LoadingSpinner';

export default function ButtonLoadingSpinner() {
  return <LoadingSpinner size="default" button />;
}
